<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 顶部搜索栏 -->
        <div class="search-bar">
          <el-input
            v-model="searchParams.name"
            placeholder="请输入角色名称"
            clearable
            style="width: 220px"
          />
          <el-button type="primary" icon="el-icon-search" @click="getMenuList">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">
            重置
          </el-button>
          <el-button type="success" icon="el-icon-plus" @click="openAddDialog">
            添加角色
          </el-button>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="角色名称" prop="name" min-width="150" />
          <el-table-column label="备注" prop="remark" min-width="150" />
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />

          <!-- 操作列 -->
          <el-table-column
            label="操作"
            width="180"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >
                编辑
              </el-button>
              <el-button
                type="text"
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
                style="color: #f56c6c"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />

        <!-- PC 添加弹窗 -->
        <el-dialog
          title="添加角色"
          :visible.sync="pcAddDialogVisible"
          width="1200px"
          @close="resetPcAddForm"
          append-to-body
        >
          <el-form
            :model="pcEditForm"
            :rules="addRules"
            ref="pcEditForm"
            label-width="100px"
          >
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="pcEditForm.name" />
            </el-form-item>

            <el-form-item label="权限设置">
              <div class="permission-panel">
                <div
                  v-for="first in menuTree"
                  :key="first.id"
                  class="menu-item"
                >
                  <div class="first-title">{{ first.name }}</div>

                  <div
                    v-for="second in first.children"
                    :key="second.id"
                    class="level-2"
                  >
                    <div class="second-title">{{ second.name }}</div>

                    <div class="level-3">
                      <el-checkbox
                        v-for="third in second.children"
                        :key="third.id"
                        v-model="pcCheckedMap[third.id]"
                      >
                        {{ third.name }}
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="备注">
              <el-input v-model="pcEditForm.remark" type="textarea" rows="3" />
            </el-form-item>
          </el-form>

          <div slot="footer" style="text-align: right">
            <el-button @click="pcAddDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitPcMenu">确认添加</el-button>
          </div>
        </el-dialog>

        <!-- PC 编辑弹窗 -->
        <el-dialog
          title="编辑角色"
          :visible.sync="pcEditDialogVisible"
          width="1200px"
          @close="resetPcEditForm"
          append-to-body
        >
          <el-form
            :model="pcEditForm"
            :rules="addRules"
            ref="pcEditForm"
            label-width="100px"
          >
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="pcEditForm.name" />
            </el-form-item>

            <el-form-item label="权限设置">
              <div class="permission-panel">
                <div
                  v-for="first in menuTree"
                  :key="first.id"
                  class="menu-item"
                >
                  <div class="first-title">{{ first.name }}</div>

                  <div
                    v-for="second in first.children"
                    :key="second.id"
                    class="level-2"
                  >
                    <div class="second-title">{{ second.name }}</div>

                    <div class="level-3">
                      <el-checkbox
                        v-for="third in second.children"
                        :key="third.id"
                        v-model="pcCheckedMap[third.id]"
                      >
                        {{ third.name }}
                      </el-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>

            <el-form-item label="备注">
              <el-input v-model="pcEditForm.remark" type="textarea" rows="3" />
            </el-form-item>
          </el-form>

          <div slot="footer" style="text-align: right">
            <el-button @click="pcEditDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitPcEditMenu"
              >确认修改</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-user-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索 -->
        <div class="mobile-search-group">
          <el-input
            v-model="searchParams.name"
            placeholder="角色名称"
            clearable
            prefix-icon="el-icon-search"
            size="medium"
          />
        </div>
        <div style="display: flex; gap: 8px; margin-bottom: 10px">
          <el-button
            type="primary"
            plain
            round
            @click="getMenuList"
            style="flex: 1"
            >搜索</el-button
          >
          <el-button plain round @click="resetSearch" style="flex: 1"
            >重置</el-button
          >
          <el-button
            type="success"
            plain
            round
            @click="openMobileAddDialog"
            style="flex: 1"
            >添加</el-button
          >
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="nickname">{{ item.name }}</div>
                <div class="uid">ID: {{ item.id }}</div>
              </div>
            </div>
            <div class="card-body">
              <div>备注：{{ item.remark || "无" }}</div>
              <div>创建：{{ item.created_at }}</div>
            </div>
            <div class="card-footer">
              <el-button
                size="mini"
                type="primary"
                round
                @click.stop="handleMobileEdit(item)"
                >编辑</el-button
              >
              <el-button
                size="mini"
                type="danger"
                round
                @click.stop="handleDelete(item)"
                >删除</el-button
              >
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>

        <!-- 移动端添加弹窗 -->
        <el-dialog
          title="添加角色"
          :visible.sync="mobileAddDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditForm"
            label-width="80px"
            size="small"
          >
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="mobileEditForm.name" size="medium" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="mobileEditForm.remark" type="textarea" rows="2" />
            </el-form-item>
            <el-form-item label="权限">
              <div class="permission-panel-mobile">
                <div
                  v-for="first in menuTree"
                  :key="first.id"
                  style="margin-bottom: 12px"
                >
                  <div style="font-weight: bold; margin-bottom: 6px">
                    {{ first.name }}
                  </div>
                  <div
                    v-for="second in first.children"
                    :key="second.id"
                    style="margin-left: 10px; margin-bottom: 8px"
                  >
                    <div style="color: #666; margin-bottom: 4px">
                      {{ second.name }}
                    </div>
                    <div
                      style="
                        margin-left: 20px;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                      "
                    >
                      <el-checkbox
                        v-for="third in second.children"
                        :key="third.id"
                        v-model="mobileCheckedMap[third.id]"
                        size="mini"
                        >{{ third.name }}</el-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              gap: 10px;
              justify-content: flex-end;
            "
          >
            <el-button size="medium" @click="mobileAddDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileMenu"
              >保存</el-button
            >
          </div>
        </el-dialog>

        <!-- 移动端编辑弹窗 -->
        <el-dialog
          title="编辑角色"
          :visible.sync="mobileEditDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileEditForm"
            :rules="addRules"
            ref="mobileEditForm"
            label-width="80px"
            size="small"
          >
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="mobileEditForm.name" size="medium" />
            </el-form-item>
            <el-form-item label="备注">
              <el-input v-model="mobileEditForm.remark" type="textarea" rows="2" />
            </el-form-item>
            <el-form-item label="权限">
              <div class="permission-panel-mobile">
                <div
                  v-for="first in menuTree"
                  :key="first.id"
                  style="margin-bottom: 12px"
                >
                  <div style="font-weight: bold; margin-bottom: 6px">
                    {{ first.name }}
                  </div>
                  <div
                    v-for="second in first.children"
                    :key="second.id"
                    style="margin-left: 10px; margin-bottom: 8px"
                  >
                    <div style="color: #666; margin-bottom: 4px">
                      {{ second.name }}
                    </div>
                    <div
                      style="
                        margin-left: 20px;
                        display: flex;
                        flex-wrap: wrap;
                        gap: 8px;
                      "
                    >
                      <el-checkbox
                        v-for="third in second.children"
                        :key="third.id"
                        v-model="mobileCheckedMap[third.id]"
                        size="mini"
                        >{{ third.name }}</el-checkbox
                      >
                    </div>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
          <div
            slot="footer"
            style="
              text-align: right;
              display: flex;
              gap: 10px;
              justify-content: flex-end;
            "
          >
            <el-button size="medium" @click="mobileEditDialogVisible = false"
              >取消</el-button
            >
            <el-button type="primary" size="medium" @click="submitMobileEditMenu"
              >保存</el-button
            >
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
export default {
  name: "MenuTable",
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      searchParams: { page: 1, page_size: 10, name: "" },
      menuTree: [],

      // PC 弹窗数据
      pcAddDialogVisible: false,
      pcEditDialogVisible: false,
      pcEditForm: { id: "", name: "", remark: "" },
      pcCheckedMap: {},

      // 移动端弹窗数据
      mobileAddDialogVisible: false,
      mobileEditDialogVisible: false,
      mobileEditForm: { id: "", name: "", remark: "" },
      mobileCheckedMap: {},

      addRules: {
        name: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getMenuList();
  },
  methods: {
    // 获取角色列表
    getMenuList() {
      this.loading = true;
      api.role
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data;
            this.pageInfo.total = res.data.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // ==================== PC 添加 ====================
    openAddDialog() {
      this.pcAddDialogVisible = true;
      this.resetPcAddForm();
      this.loading = true;
      api.role
        .addRole()
        .then((res) => {
          if (res.data.code == 1000) {
            this.menuTree = res.data.data;
            this.initPcCheckStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitPcMenu() {
      this.$refs.pcEditForm.validate((valid) => {
        if (!valid) return;
        const ids = this.getPcCheckedPermissionIds();
        const params = {
          name: this.pcEditForm.name,
          remark: this.pcEditForm.remark,
          permission: ids.join(","),
        };
        this.loading = true;
        api.role
          .add(params)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.pcAddDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== PC 编辑 ====================
    handleEdit(row) {
      this.pcEditForm = { ...row };
      this.pcEditDialogVisible = true;
      this.loading = true;
      this.pcCheckedMap = {};

      api.role
        .editRolePage({ role_id: row.id })
        .then((res) => {
          if (res.data.code == 1000) {
            this.menuTree = res.data.data.menu_data;
            this.initPcCheckStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initPcCheckStatus() {
      const loop = (list) => {
        list.forEach((item) => {
          if (item.children && item.children.length) {
            loop(item.children);
          } else {
            this.$set(this.pcCheckedMap, item.id, item.status == 1);
          }
        });
      };
      loop(this.menuTree);
    },
    getPcCheckedPermissionIds() {
      const ids = [];
      for (const id in this.pcCheckedMap) {
        if (this.pcCheckedMap[id]) {
          ids.push(id);
        }
      }
      return ids;
    },
    submitPcEditMenu() {
      this.$refs.pcEditForm.validate((valid) => {
        if (!valid) return;
        const ids = this.getPcCheckedPermissionIds();
        const params = {
          role_id: this.pcEditForm.id,
          name: this.pcEditForm.name,
          remark: this.pcEditForm.remark,
          permission: ids.join(","),
        };
        this.loading = true;
        api.role
          .editRole(params)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.pcEditDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端添加 ====================
    openMobileAddDialog() {
      this.mobileAddDialogVisible = true;
      this.resetMobileAddForm();
      this.loading = true;
      api.role
        .addRole()
        .then((res) => {
          if (res.data.code == 1000) {
            this.menuTree = res.data.data;
            this.initMobileCheckStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submitMobileMenu() {
      this.$refs.mobileEditForm.validate((valid) => {
        if (!valid) return;
        const ids = this.getMobileCheckedPermissionIds();
        const params = {
          name: this.mobileEditForm.name,
          remark: this.mobileEditForm.remark,
          permission: ids.join(","),
        };
        this.loading = true;
        api.role
          .add(params)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.mobileAddDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端编辑 ====================
    handleMobileEdit(row) {
      this.mobileEditForm = { ...row };
      this.mobileEditDialogVisible = true;
      this.loading = true;
      this.mobileCheckedMap = {};

      api.role
        .editRolePage({ role_id: row.id })
        .then((res) => {
          if (res.data.code == 1000) {
            this.menuTree = res.data.data.menu_data;
            this.initMobileCheckStatus();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    initMobileCheckStatus() {
      const loop = (list) => {
        list.forEach((item) => {
          if (item.children && item.children.length) {
            loop(item.children);
          } else {
            this.$set(this.mobileCheckedMap, item.id, item.status == 1);
          }
        });
      };
      loop(this.menuTree);
    },
    getMobileCheckedPermissionIds() {
      const ids = [];
      for (const id in this.mobileCheckedMap) {
        if (this.mobileCheckedMap[id]) {
          ids.push(id);
        }
      }
      return ids;
    },
    submitMobileEditMenu() {
      this.$refs.mobileEditForm.validate((valid) => {
        if (!valid) return;
        const ids = this.getMobileCheckedPermissionIds();
        const params = {
          role_id: this.mobileEditForm.id,
          name: this.mobileEditForm.name,
          remark: this.mobileEditForm.remark,
          permission: ids.join(","),
        };
        this.loading = true;
        api.role
          .editRole(params)
          .then((res) => {
            if (res.data.code == 1000) {
              this.getMenuList();
              this.mobileEditDialogVisible = false;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 重置方法（修复报错核心） ====================
    resetPcAddForm() {
      this.pcEditForm = { name: "", remark: "" };
      this.pcCheckedMap = {};
    },
    resetPcEditForm() {
      this.pcEditForm = { id: "", name: "", remark: "" };
      this.pcCheckedMap = {};
    },
    resetMobileAddForm() {
      this.mobileEditForm = { name: "", remark: "" };
      this.mobileCheckedMap = {};
    },
    resetMobileEditForm() {
      this.mobileEditForm = { id: "", name: "", remark: "" };
      this.mobileCheckedMap = {};
    },

    resetSearch() {
      this.searchParams = { page: 1, page_size: 10, name: "" };
      this.getMenuList();
    },

    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getMenuList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getMenuList();
    },

    // 删除（共用）
    handleDelete(row) {
      this.$confirm("此操作将永久删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          api.role
            .del({ role_id: row.id })
            .then((res) => {
              if (res.data.code == 1000) {
                this.getMenuList();
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
  },
};
</script>

<style scoped>
/* ====================== PC 样式 ====================== */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  gap: 10px;
  align-items: center;
}
.permission-panel {
  border: 1px solid #ebeef5;
  padding: 15px;
  border-radius: 4px;
  max-height: 450px;
  overflow-y: auto;
}
.menu-item {
  margin-bottom: 20px;
}
.first-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 8px;
}
.level-2 {
  margin-left: 20px;
  margin-bottom: 10px;
}
.second-title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
  margin-bottom: 6px;
}
.level-3 {
  margin-left: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

/* ====================== 移动端样式 ====================== */
.mobile-user-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  margin-bottom: 8px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.nickname {
  font-size: 16px;
  font-weight: 500;
}
.uid {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 10px;
}
.card-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.permission-panel-mobile {
  max-height: 60vh;
  overflow-y: auto;
  padding: 4px;
}
</style>


// WEBPACK FOOTER //
// src/pages/admin/role.vue